import template from './quote.html';
import controller from './quote.controller';

let quoteComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default quoteComponent;
